import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';

export interface PeriodicElement {
  dimension: string;
  tire_size: number;
  load_index: number;
  speed_rating: string;
  sidewall: string;
  price: string;
}

@Component({
  selector: 'web-promo-shared-pattern-lib-model-tire-table',
  imports: [MatButtonModule, CommonModule, MatTableModule],
  templateUrl: './lib-model-tire-table.component.html',
  styleUrl: './lib-model-tire-table.component.scss',
})
export class LibModelTireTableComponent {
  @Input() set data(data: any) {
    this.loggingService.log('@@@ INPUT | productdata', data);
    // this.productData = product;
    // this.buildDataTable(product);
    this.dataSource = data;
  }

  @Output() OnClickOpenpopup = new EventEmitter();
  clickPopup() {
    this.OnClickOpenpopup.emit('');
  }

  @Output() detailClick = new EventEmitter();
  @Output() deleteClick = new EventEmitter();

  private readonly loggingService = inject(LoggingService);

  displayedColumns: string[] = ['tire_size', 'dimension', 'load_index', 'speed_rating', 'sidewall', 'price'];
  dataSource: any;

  btnDetailClick(productId: string) {
    this.detailClick.emit(productId);
  }

  btnDeleteClick(productId: string) {
    this.deleteClick.emit(productId);
  }
}
